import React, { useContext, useState, useEffect } from 'react'
// import { loadingMiniContext } from '../../commonLib/lodingMiniContext';
import * as applicationUserCrud from '../../../../configurations/crud/applicationUserCrud'
import Container from '../../../base/Container';
import LoadingContainer from '../../../controls/LoadingContainer';
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo';
import { setLoginInfo } from '../../../../configurations/auth/setLoginInfo';
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR } from '../../../../configurations/initUrls';
import { ImageUploader } from '../../../../configurations/commonlib/ImageUploader';
import { useToast } from '../../../controls/Toast/ToastService';
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5';
import { MdErrorOutline } from 'react-icons/md';
import useGlobalLoader from '../../../../configurations/useGlobalLoader';

export function UploadDP() {
    const { start, end } = useGlobalLoader()
    const [isLoadingMini, setIsLoadingMini] = useState()
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const userData = getLoginInfo()
    const [photo, setPhoto] = useState("")
    const toast = useToast()

    const SetPhoto = (image) => {
        setPhoto(image)
    }
    useEffect(() => {
        if (photo)
            SavePhoto()
    }, [photo])
    const SavePhoto = () => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true);
        start()
        const formData = new FormData()

        formData.append('id', userData.id)
        formData.append('file', photo)
        applicationUserCrud.UploadDP(formData)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false);
                    setIsLoadingLocal(false);
                    end()
                    toast.open("Updated successfully", <IoCheckmarkDoneCircleOutline />, "success")
                    UpdateLocal(res.data.message)
                    window.location.reload()
                }
                else {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    end()
                    toast.open("Server Error /Invalid Try.", <MdErrorOutline />, 'error')
                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                setIsLoadingLocal(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const UpdateLocal = (url) => {
        let data = userData;
        data = { ...data, isDP: 1, dpUrl: url }
        setLoginInfo(JSON.stringify(data))
    }
    return (
        <>
            <div className="row">
                <div className="col-md-4">
                </div>
                <div className="col-md-4">
                    <div class="form-group">
                        <div class="col-xs-12">
                            <ImageUploader initImage={userData.isDP == 1 ? BASE_URL + "/" + userData.dpUrl : userData.gender === 0 ? MALE_DR_AVATAR : FEMALE_DR_AVATAR} SetImage={SetPhoto} />
                        </div>
                    </div>
                </div>
            </div>

            {photo && <div class="clearfix form-actions mt-2">
                <div class="pull-right">
                    {isLoadingLocal &&
                        <LoadingContainer text={"Uploading Photo..."} />
                        // :
                        // <button type="submit" expand="block" onClick={SavePhoto} disabled={!photo} class="bg-indigo-800 text-white px-4 py-2 rounded-lg hover:bg-blue-900 transition-colors duration-300 ring ring-gray-300 hover:ring-indigo-300">
                        //     Upload
                        // </button>
                    }
                </div>
            </div>}
        </>

    )
}
